import { Tooltip, Typography } from "antd";
import { StyledFlex } from "../Table/index.styled";
import { Provider } from "@lib/types/Provider";
import { Link } from "react-router-dom";
import ProviderLogo from "./ProviderLogo";
import { shortenString } from "@lib/helpers/StringHelper";
import { ROUTES } from "@lib/constants";
import { getRoute } from "@lib/helpers/RouteHelper";
import { useMemo } from "react";
import { useTypedSelector } from "@lib/redux";
import { AuthRoles } from "@lib/types";
import { AvatarSize } from "@lib/types/General";

type Props = {
  provider: Provider;
  link?: boolean;
  logoWidth?: number;
  titleMaxLength?: number;
  preview?: boolean;
  size?: AvatarSize;
};

export default function ProviderName({
  provider,
  link,
  titleMaxLength = 15,
  size = "medium",
}: Props) {
  const { user } = useTypedSelector((state) => state.auth);

  const providerName = provider?.name || " N/A ";

  const providerLink = useMemo(() => {
    if (!provider) return null;
    switch (user?.role) {
      case AuthRoles.Admin:
        return getRoute(ROUTES.ADMIN.PAYMENT_PROVIDER.DETAIL, {
          providerId: provider?.id,
        });
      default:
        return null;
    }
  }, [user]);

  if (!provider) return providerName;

  if (link && providerLink) {
    return (
      <StyledFlex style={{ gap: 5 }}>
        <Link to={providerLink}>
          <ProviderLogo provider={provider} size={size} />
        </Link>
        <Tooltip title={providerName}>
          <Link to={providerLink} style={{ cursor: "pointer" }}>
            {shortenString(providerName, titleMaxLength)}
          </Link>
        </Tooltip>
      </StyledFlex>
    );
  }

  return (
    <StyledFlex style={{ gap: 5 }}>
      <ProviderLogo provider={provider} size={size} />
      <Tooltip title={providerName}>
        <Typography.Text>
          {shortenString(providerName, titleMaxLength)}
        </Typography.Text>
      </Tooltip>
    </StyledFlex>
  );
}
